let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("502QZ")).then(() => parcelRequire('cudcu'));